import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import GreenLogo from "../Innovators/GreenLogo";

const HomeFooterAlt = () => {
  return (
    <Fragment>
      <footer className="fixed">
        <ul className="footer-all-links">
          <div className="copyright">
            <GreenLogo /> <i className="fas fa-trademark mx-10 green"></i>2026
          </div>
          <Link to="/about">
            <li className="footer-link green">About ime</li>
          </Link>
          <Link to="/advertising">
            <li className="footer-link green">Advertising</li>
          </Link>
          <Link to="/calendar">
            <li className="footer-link green">Calendar</li>
          </Link>
          <Link to="/faq">
            <li className="footer-link green">FAQ</li>
          </Link>
          <Link to="/terms">
            <li className="footer-link green">Terms of Agreement</li>
          </Link>
          <Link to="/privacypolicy">
            <li className="footer-link green">Privacy Policy</li>
          </Link>
          <Link to="/cookiepolicy">
            <li className="footer-link green">Cookie Policy</li>
          </Link>
          {/* <li className="footer-link-social">
            <i className="fab fa-facebook-f fa-icons"></i>
            <i className="fab fa-snapchat fa-icons"></i>
            <i className="fa-brands fa-x-twitter fa-icons"></i>
            <i className="fab fa-instagram fa-icons"></i>
            <i className="fab fa-tiktok fa-icons"></i>
          </li> */}
        </ul>
      </footer>
    </Fragment>
  );
};

export default HomeFooterAlt;
